import { render } from "./AddressOutput.vue?vue&type=template&id=f8373208&ts=true"
import script from "./AddressOutput.ts?vue&type=script&lang=ts&external"
export * from "./AddressOutput.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__